<template>
    <div class="apprentice-simple-card skilltree-edit">
        <design-2021-orgchart-component
            :nodes-in="nodes"
            :skill-tree-in="skillTreeIn"
            :rubrics-in="rubricsIn">
        </design-2021-orgchart-component>
    </div>
</template>

<script>

export default {
    name: "design-2021-skilltree-edit-component",
    props: [
        'skillTreeIn',
        'rubricsIn',
    ],
    computed: {
        nodes(){
            let nodes = [
                {
                    id: 0,
                    name: this.skillTreeIn.name,
                    rubric: '',
                    tags: ["overrideMenu"]
                }
            ]

            for (const skillSkillTree of this.skillTreeIn.skill_skill_trees) {
                nodes.push({
                    id: skillSkillTree.id,
                    name: skillSkillTree.skill.name,
                    pid: skillSkillTree.parent_skill_id ? skillSkillTree.parent_skill_id : 0,
                    skill_id: skillSkillTree.skill.id,
                    rubrics: skillSkillTree.rubricables
                })
            }

            return nodes;
        }
    },
}
</script>

<style scoped lang="scss">
    ::v-deep .chart-menu {
        div {
            &[data-item="edit"] i,
            &[data-item="add"] i,
            &[data-item="rubric"] i{
                color: $primary
            }

            &[data-item="remove"] i{
                color: $danger
            }

            i {
                font-size: $default-font-size;
            }

            > span {
                color: $text-color;
            }
        }
    }
</style>
